/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerProject_CommonData.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Project Common Data
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, June 29, 2019 - 8:33 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      06/29/2019  NJN     File Created
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PROJECTJOB_SET_GROUP_SELECT,
    PROJECTJOB_SET_FILTER,
    PROJECTJOB_LIST_COMPLETE,
} from '../constants/actionTypeProject_ProjectJobs';

const defaultState = {
    refreshList: false,
    projectJobListsLoaded: false,
    job_projectid_f: 0,
    job_parentid_f: 0,
    job_jobtypeid_f: 0,
    job_sourceid_f: 0,
    job_sourceid_f_display: 'Show All Users',
    job_assignedid_f: 0,
    job_assignedid_f_display: 'Show All Users',
    job_priorityid_f: 0,
    job_severityid_f: 0,
    job_statusid_f: 0,
    job_versionfoundid_f: 0,
    job_versiontargetid_f: 0,
    job_versionfixedid_f: 0,
    job_audituserid_f: 0,
    job_audituserid_f_display: 'Show All Users',
    users: [],
    job_histories: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PROJECTJOB_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case PROJECTJOB_SET_FILTER:
            return {
                ...state,
                [action.key]: action.value ? action.value : 0
            }
        case PROJECTJOB_LIST_COMPLETE:
            return {
                ...state,
                projectJobListsLoaded: true
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/reducerProject_CommonData.js